export default __webpack_public_path__ + "images/instagram.fefc1f012ec5bd0e7beba7d488d8cece.svg";